import { Component, OnInit } from '@angular/core';
import {TransporterCore} from './transporter.core';
import {FormBuilder} from '@angular/forms';
import {ApiBaseService} from '../../services/migrate/api.base.service';
import {VehiclesMenuService} from '../../services/vehicles-menu.service';
import {TransporterService} from '../../services/transporter.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {Transporter} from '../../models/transporter.model';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../models/User.model';
import storageX from '../../storageCore/storageX';
import {STORAGE_KEY_CURRENT_USER} from '../../storageCore/constStorageKeys';
import ApiService from '../../services/api.service';
import {PerfilUsuario} from '../../models/PerfilUsuario.model';

@Component({
  selector: 'app-edit-transporter',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class EditTransporterComponent extends TransporterCore implements OnInit {
  public title = 'Atualizar Transportador/Agregado';
  public formMode: any;
  public titleVar = '';
  public registrationTypes: Array<any>;
  public hide = true;
  public transporterUuid = '';


  constructor(formBuilder: FormBuilder,
              apiBaseService: ApiBaseService,
              service: ApiService,
              vehicleService: VehiclesMenuService,
              transporterService: TransporterService,
              spinner: NgxSpinnerService,
              private activatedRoute: ActivatedRoute,
              router: Router) {
    super(formBuilder, apiBaseService, vehicleService, service, transporterService, spinner, router);
    this.transporterService = transporterService;
    this.service = service;
    this.transporterFormGroup = super.loadFormDefinition();
    this.userFormGroup = super.loadUserFormDefinition();
  }

  ngOnInit(): void {
    console.log('Iniciando o componente de edição do transportador');
    this.transporterUuid = this.activatedRoute.snapshot.params.uuid;
    this.formMode = 'edit';
    this.userFormGroup.removeControl('password');
    this.registrationTypes = this.getRegistrationType();
    this.loadTransporter(this.transporterUuid, false);
  }
  submitForm(): void {
    this.updateTransporter();
  }

  private updateTransporter(): void {
    this.spinner.show();

    const selectedProfile = this.userFormGroup.get('profile')?.value;
    if (!selectedProfile || !this.userProfiles || !this.transporter) {
      this.spinner.hide();
      this.errorMessage = 'Dados necessários não encontrados';
      throw new EvalError(this.errorMessage);
    }

    if (!this.transporter.userId) {
      this.spinner.hide();
      this.errorMessage = 'ID do usuário não encontrado para atualização';
      throw new EvalError(this.errorMessage);
    }

    const userUpdate = {
      cdUsuario: this.userFormGroup.get('login').value,
      nmUsuario: this.userFormGroup.get('userName').value,
      dsEmail: this.userFormGroup.get('email').value,
      nrMatricula: this.userFormGroup.get('matriculation').value,
      ativo: true,
      idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
    };

    console.log('Atualizando usuário no api-base...');

    this.apiBaseService.put<User>(
      this.transporter.userId,
      new User().nomeConsultaApiBase,
      userUpdate
    ).then(() => {
      console.log('Usuário atualizado com sucesso no api-base');
      this.updateUserProfile(selectedProfile);
    }).catch(error => {
      this.spinner.hide();
      this.errorMessage = 'Erro ao atualizar usuário: ' + error.message;
      throw new EvalError(this.errorMessage);
    });
  }

  private updateUserProfile(selectedProfile: any): void {
    console.log('Atualizando perfil do usuário via agregation...');

    const perfilUsuarioRequest = {
      perfil: { id: selectedProfile.id },
      usuario: { id: this.transporter.userId },
      flLeitura: true,
      flInsercao: true,
      flAtualizacao: true,
      flDelecao: true,
    };

    this.apiBaseService.put<PerfilUsuario>(
      this.transporter.userId,
      'usuario-perfil/agregation',
      perfilUsuarioRequest
    ).then(() => {
      console.log('Perfil atualizado com sucesso via PUT /agregation');
      this.updateTransporterData();
    }).catch(error => {
      this.spinner.hide();
      this.errorMessage = 'Erro ao atualizar perfil: ' + error.message;
      throw new EvalError(this.errorMessage);
    });
  }



  private updateTransporterData(): void {
    console.log('Atualizando o transporter...');
    
    if (!this.transporter) {
      this.spinner.hide();
      this.errorMessage = 'Transporter não encontrado';
      throw new EvalError(this.errorMessage);
    }
    
    const transporter = new Transporter(this.transporterFormGroup.value);
    transporter.userId = this.transporter.userId;
    if (transporter.postalCode) {
      transporter.postalCode = transporter.postalCode.replace('-', '');
    }

    const registrationType = this.transporterFormGroup.controls.registrationType.value;
    if (registrationType === 'Matriz' || registrationType === 'Filial') {
      transporter.companyId = this.transporterFormGroup.controls.company.value?.id;
    }
    if (registrationType === 'Divisão') {
      transporter.divisionId = this.transporterFormGroup.controls.company.value?.id;
    }

    const vehiclesValue = this.userFormGroup.get('vehicles')?.value;
    if (vehiclesValue) {
      transporter.vehicles = vehiclesValue.map((vehicle: any) => vehicle.id_veiculo);
    }
    
    this.transporterService.update(transporter, this.transporter.uuid || '').subscribe((persistedTransporter) => {
      console.log(persistedTransporter);
      this.spinner.hide();
      this.router.navigate(['/transporters']);
    }, (error) => {
      console.log(error);
      this.spinner.hide();
      this.errorMessage = 'Erro ao atualizar transporter: ' + error.message;
      throw new EvalError(this.errorMessage);
    });
  }


}
